<template>
  <div>
    <div class="step-container">
      <div class="step">
        <label>Bước 1: Tải xuống file mẫu</label>
        <button class="btn btn-primary w-130" @click="downloadFileExcelExample">
          <i class="el-icon-bottom text-white"></i> Tải xuống
        </button>
      </div>
      <div class="step">
        <label>Bước 2: Tải file excel lên hệ thống</label>
        <div v-if="fileImport" class="file-info">
          <span>{{ fileImport.name }}</span>
          <el-button type="text" @click="removeFile" class="btn-remove">
            <i class="el-icon-delete text-danger"></i>
          </el-button>
        </div>
        <label v-else class="btn btn-warning w-130" for="upload-file-level">
          <input
              type="file"
              id="upload-file-level"
              hidden
              @change="handleFileUpload"
              accept=".xlsx, .xls"
          />
          <i class="el-icon-top text-white"></i> Tải lên
        </label>
      </div>
    </div>

    <div class="footer-actions">
      <el-button type="info" style="color: white" @click="closeDialog">
        Hủy
      </el-button>
      <el-button
          type="success"
          :disabled="!fileImport || dataImport.length === 0"
          style="background: #1BC5BD; color: white; border-color: #1BC5BD;"
          v-loading="loadingImport"
          @click="confirmImport"
      >
        Xác nhận
      </el-button>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "ImportLevelEmployee",
  data() {
    return {
      fileImport: null,
      dataImport: [],
    };
  },
  props: {
    loadingImport: Boolean,
    default: () => {
      return false
    }
  },
  methods: {
    downloadFileExcelExample() {
      const link = document.createElement("a");
      link.href = `${process.env.BASE_URL}excel/File mẫu import tiêu chí Teamlead.xlsx`;
      link.download = "File mẫu import tiêu chí Teamlead.xlsx";
      link.click();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.fileImport = file;
      this.parseExcel(file);
    },

    removeFile() {
      this.fileImport = null;
      this.dataImport = [];
    },

    closeDialog() {
      this.$emit("closeDialog");
    },

    confirmImport() {
      if (!this.fileImport || this.dataImport.length === 0) {
        this.$message?.warning?.("Chưa có dữ liệu để import");
        return;
      }
      this.$emit("importData", this.dataImport);
    },

    parseExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const workbook = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rawData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (!rawData || rawData.length === 0) {
          this.$message?.warning?.("File excel không có dữ liệu");
          return;
        }

        const [headers, ...rows] = rawData;
        const columnMap = {
          "Mã nhân sự": "ma_nhan_su",
          "Nhiệm vụ": "nhiem_vu",
          "Loại chỉ số": "loai_chi_so",
          "Tên chỉ số": "ten_chi_so",
          "Trainee": "trainee",
          "Junior 1": "junior_1",
          "Junior 2": "junior_2",
          "Member 1E": "member_1e",
          "Member 1D": "member_1d",
          "Member 1C": "member_1c",
          "Member 1B": "member_1b",
          "Member 1A": "member_1a",
          "Member 2E": "member_2e",
          "Member 2D": "member_2d",
          "Member 2C": "member_2c",
          "Member 2B": "member_2b",
          "Member 2A": "member_2a",
          "Senior 1E": "senior_1e",
          "Senior 1D": "senior_1d",
          "Senior 1C": "senior_1c",
          "Senior 1B": "senior_1b",
          "Senior 1A": "senior_1a",
          "Senior 2E": "senior_2e",
          "Senior 2D": "senior_2d",
          "Senior 2C": "senior_2c",
          "Senior 2B": "senior_2b",
          "Senior 2A": "senior_2a",
          "Expert 1E": "expert_1e",
          "Expert 1D": "expert_1d",
          "Expert 1C": "expert_1c",
          "Expert 1B": "expert_1b",
          "Expert 1A": "expert_1a",
          "Expert 2E": "expert_2e",
          "Expert 2D": "expert_2d",
          "Expert 2C": "expert_2c",
          "Expert 2B": "expert_2b",
          "Expert 2A": "expert_2a",
        };

        const mappedHeaders = headers.map((h) => columnMap[h] || h);

        this.dataImport = rows
          .filter((row) => row && row.length > 0)
          .map((row) => {
            const item = {};
            mappedHeaders.forEach((key, i) => {
              item[key] = row[i];
            });
            return {
              ...item,
            };
          });

        this.$message?.success?.(
          `Đọc file excel thành công (${this.dataImport.length} dòng dữ liệu)`
        );
      };
      reader.readAsArrayBuffer(file);
    },
  },
};
</script>

<style scoped>
.step-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step {
  display: flex;
  flex-direction: column;
}

.w-130 {
  width: 130px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.text-white {
  color: white;
}

.text-danger {
  color: red !important;
}
</style>

